import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { PatientDemographicsService } from '../../patientDemographics/services/patientDemographics.service'
import { setPhoneTypeOptions } from '../store/options.actions'
import { IOptionsResponse } from '../../../common/common.types'

export function* getPhoneTypeOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const patientDemographicsService = new PatientDemographicsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([
      patientDemographicsService,
      patientDemographicsService.getPhoneTypeOptions,
    ])
    const { entity } = response
    yield put(setPhoneTypeOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getPhoneTypeOptions() error: ${e}`))
  }
}

export function* getPhoneTypeOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getPhoneTypeOptions)
}
